/* eslint-disable camelcase */
export enum SignaturePlanTypes {
  GET_PLAN_REQUEST = '@plan/GET_PLAN_REQUEST',
  GET_PLAN_SUCCESS = '@plan/GET_PLAN_SUCCESS',
  GET_PLAN_FAILURE = '@plan/GET_PLAN_FAILURE',
  SIMULATE_ALL_REQUEST = '@plan/SIMULATE_ALL_REQUEST',
  SIMULATE_ALL_SUCCESS = '@plan/SIMULATE_ALL_SUCCESS',
  SIMULATE_ALL_FAILURE = '@plan/SIMULATE_ALL_FAILURE',
}
export interface ServiceTypes {
  descricao: string | null;
  id: number;
  nome: string;
  plano: string;
  quantidade: number;
  status_id: number;
  valor: number;
  valor_adicional: number;
  valor_servico: number;
  valor_servico_cartao: number;
  valor_unitario: string;
}

export interface OriginalTypes {
  servicos: Array<ServiceTypes>;
  total_maximo_parcelas: number;
  valor_adicional: number;
  valor_base: number;
  valor_final: number;
  valor_negociacao: number;
  valor_parcela: number;
  valor_total_no_cartao: number;
  valor_variacao_forma_pagamento: number;
}

export interface PlanTypes {
  exception: null;
  headers: object;
  original: OriginalTypes;
}

interface Plan {
  parcelas: string;
  valor_base: number;
  valor_cartao: number;
}

export interface PlansTypes {
  planos: {
    [key: string]: {
      [key: string]: PlanTypes;
    };
  };
  plans_all: {
    semestral: Plan;
    anual: Plan;
    bienal: Plan;
  };
}

export interface LayoutTypes {
  layout: string;
  plano_id: number;
  plano: string;
  renewal: boolean;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface PlansState {
  plans: PlansTypes;
  current_layout: LayoutTypes;
  readonly request: RequestState;
}
